import React, { useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"
import { motion, useAnimation } from "framer-motion"
import htmlSerializer from "../../utils/htmlSerializer"
import { RichText } from 'prismic-reactjs'


const ImageBlock = ({ slice }) => {
  const controls = useAnimation()
  const [ref, inView] = useInView({
    threshold: 0.4,
  })

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  const item = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
      },
    },
  }

  return (
    <motion.div
      ref={ref}
      animate={controls}
      transition={{
        type: "tween",
        ease: "easeIn",
        delay: 0.25,
      }}
      initial="hidden"
      // className={`${inView ? "reveal" : ""}`}
      // className={inView ? "fade-in" : ""}
      // className="section container callouts"
      variants={{
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.8,
          },
        },
        hidden: {
          opacity: 0,
          y: 50,
        },
      }}
    >
      <section className="section image-block">
        {/* <img className="bg-img" src={slice.primary.image.url} /> */}
        <picture>
          <source
            srcSet={slice.primary.image.thumbnails.Mobile.url}
            // srcSet={g.image.fluid.srcSet.mobile}
            // alt={g.image.fluid.mobile.alt}
            media="(max-width: 400px)"
          />
          <source
            srcSet={slice.primary.image.thumbnails.Tablet.url}
            // alt={g.image.fluid.tablet.alt}
            media="(max-width: 900px)"
          />
          <img className="image-block__bg-img"
            src={slice.primary.image.thumbnails.Desktop.url}
            // alt={g.image.fluid.desktop.alt}
          />
        </picture>

        <div className="image-block__content">
            <motion.div
              ref={ref}
              transition={{
                type: "tween",
                ease: "easeIn",
                delay: 0.25,
              }}
              className="CardWrap"
              variants={item}
              initial="hidden"
              animate={controls}
            >
              <h2 className="title">{slice.primary.title.text}</h2>

            </motion.div>
        </div>
      </section>
    </motion.div>
  )
}

export default ImageBlock
